import React, { useState } from 'react';
import styled from 'styled-components';
import DropdownItem from "react-bootstrap/DropdownItem";
import { DropdownButton } from "react-bootstrap";
import { Black, WerfenColor, White } from '../../Constants/ColorChart'

/*
 *  @Description:   Component that renders a button that deploys a context menu
 */

const DropdownWrapper = styled.div`
    box-shadow: 0 0 0 transparent !important;
    display: flex;
    align-items: center;
    & label {
        padding-right: 20px;
    }
    & .dropdown-item {
        padding:0;
    }
`;

const Wrapper = styled( DropdownButton )`
    display: inline-block;
    & .dropdown-toggle{    
        border: 0 none transparent;
        background: transparent!important;
        color: ${ White }!important;
        &:hover, &:active, &:focus{
            color: ${ White };
            background: transparent;
        }
    }
    & + ul {
      width: max-content
    }
`;

const MenuDiv = styled.div`
    color: ${ Black };
  padding: 15px 30px;
  font-size: 18px;
  &:hover{
    background: ${ WerfenColor };
    color: ${ White };
  }
`;

const DropdownMenu = ( props ) => {
    const { id, contextActions } = props;
    const [ selected, setSelected ] = useState( "All" );
    const [ dropdownIsOpen, setDropdownIsOpen ] = useState( false );

    const handleSelected = ( value, callback ) => {
        setSelected( value );
        callback();
        toggleDropdown();
    }

    const toggleDropdown = () => {
        setDropdownIsOpen( !dropdownIsOpen );
    }

    return (
        <DropdownWrapper>
            <label>Now Showing:</label>
            <Wrapper
                className={ "dropdown-here" }
                variant={ "default" }
                size="lg"
                id={ "filters" + id }
                title={ selected }
                onToggle={ toggleDropdown }
                open={ dropdownIsOpen }
            >
                {
                    contextActions ?
                        contextActions.map( ( { name, action } ) => {
                            if ( name === "Todos" ) {
                                name = "All"
                            }
                            return (
                                <DropdownItem
                                    key={ name }
                                    value={ name }
                                    onClick={ () => {
                                        handleSelected( name, action );
                                    } }
                                >
                                    <MenuDiv>{ name }</MenuDiv>
                                </DropdownItem>
                            )
                        } )
                        :
                        <DropdownItem key="NA">
                            <MenuDiv>N/A</MenuDiv>
                        </DropdownItem>
                }
            </Wrapper>
        </DropdownWrapper>
    )
}

export default DropdownMenu;
